/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />

module App.Common.Services {
	'use strict';

	export class DateHelperService {

		public differenceSeconds(start: Date, end: Date): number {
			return Math.floor((end.valueOf() - start.valueOf()) / 1000);
		}

		public formatShortTimespan(seconds: number): string {
			var minutes = Math.floor(seconds / 60);
			var remainderSeconds = Math.floor(seconds % 60);
			return `${_.padStart(minutes.toString(), 2, '0')}:${_.padStart(remainderSeconds.toString(), 2, '0')}`;
		}

	}

	angular
		.module('app.common.services')
		.service('app.common.services.dateHelperService', DateHelperService);
}